module.exports = __webpack_public_path__ + "img/app-icon.ca3b6641.png";